import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import { unregister } from "./registerServiceWorker";
// import { getLocale } from "./helpers";
import moment from "moment";
import "moment/min/locales";

import tr from 'javascript-time-ago/locale/tr'
import TimeAgo from 'javascript-time-ago'

import { ConfigProvider } from "antd";
import trTR from "antd/lib/locale/tr_TR";
// import enUS from "antd/lib/locale/en_US";

moment.locale("tr");
TimeAgo.addLocale(tr)

ReactDOM.render(
  <Provider store={store}>
      {/* <ConfigProvider locale={getLocale() === "tr-TR" ? trTR : enUS}> */}
      <ConfigProvider locale={trTR}>
      <App />
    </ConfigProvider>
  </Provider>,
  document.getElementById("root")
);

unregister();



// WEBPACK FOOTER //
// ./src/index.js